import React from 'react';
const PGHostels = () => <div className="service-page"><h1>PG/Hostels</h1><p>Comfortable PGs and hostels for students and working professionals.</p></div>;
export default PGHostels;
